import {useQuery} from "react-query";
import  groupService from "../../services/GroupService";

export default function useGroup(id: number) {
   return useQuery(['group', id], () =>  groupService.findById(id));
}